import React from 'react';
import { Controller, useFormContext } from "react-hook-form";
import { useWizard } from 'rhf-wizard';
import GoogleMap from './components/GoogleMap';
import ErrorPanel from './components/ErrorMessage';
import { FilePond } from 'react-filepond';
import CustomScroll from './components/CustomScroll';
const Step1 = () => {
    const { setIsLoading } = useWizard();
    const { control } = useFormContext();
    return (React.createElement(CustomScroll, null,
        React.createElement("div", { className: "modal-grid", style: { flex: 1 } },
            React.createElement("div", { className: "modal-left-column" },
                React.createElement("h2", null, "Let's start with your project location"),
                React.createElement("p", { className: 'mb-0' }, "Choose how you'd like to define your project location:"),
                React.createElement("p", null, "select a point on the map, draw an area or upload your own file"),
                React.createElement(Controller, { name: "locationFile", control: control, render: ({ field }) => (React.createElement(FilePond, { allowMultiple: false, maxFiles: 1, server: {
                            url: "/ajax/file-upload.php",
                        }, onprocessfilestart: () => setIsLoading(true), onprocessfile: (error, file) => {
                            field.onChange(file.serverId);
                            setIsLoading(false);
                        }, onremovefile: () => {
                            field.onChange("");
                        }, name: "fileUpload", credits: false, allowFileSizeValidation: true, maxFileSize: "10MB", chunkForce: true, chunkUploads: true, chunkSize: 5 * 1000 * 1000, labelIdle: "<p>Upload Your Area File</p><p><small>Import in one of the following<br />formats: .pdf, .doc, .docx, .odt or .rtf</small></p><span class=\"filepond--label-action btn btn-blue-reverse\">Import</span>", allowFileTypeValidation: true, acceptedFileTypes: [
                            //pdf
                            "application/pdf",
                            //dox
                            "application/msword",
                            //docx
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                            //odt
                            "application/vnd.oasis.opendocument.text",
                            //rtf
                            "application/rtf",
                            //png
                            "image/png",
                        ] })) }),
                React.createElement(ErrorPanel, { name: "locationArea" })),
            React.createElement("div", { className: "modal-right-column map-column" },
                React.createElement(GoogleMap, null)))));
};
export default Step1;
